import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Lightbox from 'yet-another-react-lightbox';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

const ImageLightBox = NiceModal.create(
  (props: { images: string[]; index: number }) => {
    const modal = useModal();

    return (
      <Lightbox
        open={modal.visible}
        plugins={[Counter, Zoom]}
        counter={{ container: { style: { top: 'unset', bottom: 0 } } }}
        close={() => {
          modal.hide();
          setTimeout(() => {
            modal.remove();
          }, 200);
        }}
        slides={props.images.map((i) => ({ src: i }))}
        index={props.index}
        zoom={{ maxZoomPixelRatio: 10 }}
        controller={{ closeOnBackdropClick: true }}
        render={{ iconZoomIn: () => null, iconZoomOut: () => null }}
        styles={{
          'container': {
            // backgroundColor: 'rgb(0 200 200 / 95%)',
            // backdropFilter: 'blur(30px)',
          },
          'button': {
            filter: 'none',
          },
        }}
      />
    );
  }
);

export default ImageLightBox;
